/* eslint-disable sort-keys */
const color = brand => {
  const brandTheme = {
    Hotwater: 1,
    Whirlpool: 2,
    State: 6,
    Lowes: 8
  };
  const def = {
    // Backgrounds
    backgroundDisabled: '#eee',
    backgroundLight: '#f7f7f7',

    // Borders
    borderPrimary: '#b5b5b5',
    borderSecondary: '#f0f0f0',

    // Buttons
    buttonColor: '#51a949',
    buttonTextColor: '#fff',

    // Primary
    black: '#000',
    primary: '#51a949',
    white: '#fff',
    lightGrey: '#eee',
    medGrey: '#a9a9a9',
    darkGrey: '#545454',

    // Status
    statusError: '#e45e5e',
    statusSuccess: '#51a949',
    statusWarning: '#fcdb0d',

    // Text
    textDark: '#333',
    textDefault: '#575855',
    textDisabled: '#c5c5c4',
    textInverse: '#fff',
    textLight: '#ddd'
  };
  switch (brand) {
    case brandTheme.Hotwater:
      return {
        ...def,
        buttonStepColor: '#51a949'
      };
    case brandTheme.Lowes:
      return {
        ...def,
        buttonColor: '#147933',
        buttonStepColor: '#147933',
        primary: '#147933',
        statusSuccess: '#147933'
      };
    case brandTheme.Whirlpool:
    default:
      return {
        ...def,
        buttonColor: '#d7b75d',
        buttonStepColor: '#eeb111',
        buttonStepColorHover: '#ca960e',
        buttonHelpBgColorHover: '#dedede',
        primary: '#d7b75d',
        statusSuccess: '#008dd0'
      };
  }
};

export const deviceWidth = {
  mobilePhone: '450px',
  largePhone: '600px',
  tablet: '800px',
  desktop: '1000px'
};

export const font = {
  primary: "'Helvetica', 'Arial', sans-serif",
  buttonTextFont: "'Neue Helvetica', 'Arial', sans-serif"
};

export const fontWeight = {
  black: '900',
  bold: '700',
  semibold: '600',
  regular: '400',
  light: '300',
  extralight: '200'
};

export const media = {
  largePhone: `(max-width: ${deviceWidth.largePhone})`,
  mobilePhone: `(max-width: ${deviceWidth.mobilePhone})`,
  tablet: `(max-width: ${deviceWidth.tablet})`,
  desktop: `(max-width: ${deviceWidth.desktop})`
};
/* eslint-enable sort-keys */

export default brand => ({
  color: color(brand),
  deviceWidth,
  font,
  fontWeight,
  media
});



// WEBPACK FOOTER //
// ./src/styles/theme.js